export default {
	removePropertiesFromObject: function (obj, removable) {
		for (var i = 0; i < removable.length; i++) {
			if (obj.hasOwnProperty(removable[i])) {
				delete obj[removable[i]];
			}
		}
	},
	getValueByPath: function (obj, path) {
		path = path.split('.');
		var returnValue = [];
		for (var i = 0; i < path.length; i += 1) {
			returnValue = !i ? obj[path[i]] : returnValue[path[i]];
		}
		return returnValue;
	}
};
